import {useEffect, useRef} from 'react';
import {getPingCheckServer} from './fetch_api/api_common.js';
import { toast, Zoom, Slide, Flip, Bounce } from 'react-toastify';
import CryptoJS from 'crypto-js';

export const setCookie =(name, value, exp) => {
    let date = new Date();
    date.setTime(date.getTime()+exp);
    document.cookie = name+"="+value+";expires="+date.toUTCString()+";path=/";
};

export const getCookie = (name) => {
    let val = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return val ? val[2] : null;
};

export const deleteCookie = (name) => {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;';
}

// export const reissueToken = () => {
//     // let userName = getDecryptCookie('using');

//     postApiToken()
//     .then(data => {
//         let accessTokenExpMinute = data.accessTokenExpMinute;
//         let accessTokenExp = 1000*60*accessTokenExpMinute;
//         let accessToken = data.accessToken;
        
//         setCookie('accessToken', accessToken);

//         let date = new Date();
//         let expDate = String(date.setTime(date.getTime() + accessTokenExp));
        
//         setCookie('accessTokenExp', expDate);

//         setTimeout(() => {
//             setCookie('tokenStatus', 'false');
//         }, 100);
//     })
//     .catch(err => {})
// }

// export const calcStep = (term) => {
//     let result = 1;
  
//     switch (term) {
//         case "1":
//             result = 1;
//             break;
//         case "5":
//             result = 1;
//             break;
//         case "15":
//             result = 5;
//             break;
//         case "30":
//             result = 5;
//             break;
//         case "60":
//             result = 5;
//             break;
//         case "180":
//             result = 12;
//             break;
//         case "360":
//             result = 24;
//             break;
//         case "720":
//             result = 48;
//             break;
//         case "1440":
//             result = 96;
//             break;
//         default:
//             result = 1;
//             break;
//     }
//     return result;
// }

export const gotoLoginBtn = () => {
    // document.getElementById('gotoBtn').addEventListener("click", function(){
        deleteCookie('accessToken');
        deleteCookie('accessTokenExp');
        deleteCookie('refreshToken');
        deleteCookie('refreshTokenExp');
        deleteCookie('type');
        deleteCookie('using');
        deleteCookie('term');
        deleteCookie('refresh');
        deleteCookie('accessTokenIntvID');
        deleteCookie('tokenStatus');

        window.location.href="/";
    // });
}

// export const checkCookieNull = () => {

//     let result = false;

//     let accessToken = getCookie('accessToken');
//     let accessTokenExp = getCookie('accessTokenExp');
//     let refreshToken = getCookie('refreshToken');
//     let refreshTokenExp = getCookie('refreshTokenExp');
//     let type = getCookie('type');
//     let userName = getDecryptCookie('using');
//     let refresh = getCookie('refresh');
//     let term = getCookie('term');
//     let accessTokenIntvID = getCookie('accessTokenIntvID');

//     if( accessToken === null ||
//         accessTokenExp === null ||
//         refreshToken === null ||
//         refreshTokenExp === null ||
//         type === null ||
//         userName === null ||
//         refresh === null ||
//         term  === null ||
//         accessTokenIntvID  === null
//     )
//     {
//         document.getElementById("gotoModal").style.display = "block"
//         document.getElementById("gotoModal").classList.add("show");
//         document.querySelector("#gotoModal .div-title").textContent = "The session has expired or deleted!";
       
//         gotoLoginBtn();
//         result = true;
//     }

//     return result;
// }

// export const errorProcess = (err) => {
//     let errorStatus = err.status;
//     let errDetail = err.responseJSON.detail;

//     if ( errorStatus === 403 ) {
        
//         let notAuth = errDetail.indexOf('Not authenticated');
//         let invalidAuth = errDetail.indexOf('Invalid authentication');
//         let expiredToken = errDetail.indexOf('expired');
//         let invalidToken = errDetail.indexOf('Invalid token');

//         if (notAuth !== -1 || invalidAuth !== -1 || expiredToken !== -1 || invalidToken !== -1) {

//             document.getElementById("gotoModal").style.display = "block"
//             document.getElementById("gotoModal").classList.add("show");
//             document.querySelector("#gotoModal .div-title").textContent = errDetail;
//             document.querySelector("#gotoModal .div-message").textContent = "";

//         }
//     } else if (errorStatus === 401) {

//         let existServerMsg = errDetail.msg;
//         let timeMsg = errDetail.time;
//         let existServer = existServerMsg.indexOf('Does not exist on the server');
//         let temp = new Date(timeMsg * 1000);

//         let existTimeMsg = `${temp.getMonth()+1}/${temp.getDate()}/${temp.getFullYear()} ${temp.getHours()}:${temp.getMinutes()}:${temp.getSeconds()}`;

//         if (existServer !== -1) {

//             document.getElementById("gotoModal").style.display = "block"
//             document.getElementById("gotoModal").classList.add("show");
//             document.querySelector("#gotoModal .div-title").textContent = "This account logged in from other device";
//             document.querySelector("#gotoModal .div-message").textContent = existTimeMsg;
//         }

//     } else if (errorStatus === 500) {
//         let serverError = errDetail.indexOf('Server Error');

//         if (serverError !== -1) {
//             document.getElementById("gotoModal").style.display = "block"
//             document.getElementById("gotoModal").classList.add("show");
//             document.querySelector("#gotoModal .modal-title").textContent = "&nbsp;";
//             document.querySelector("#gotoModal .div-title").textContent = "Server Error!";
//             document.querySelector("#gotoModal .div-title").style.color = "#dc3545";
//             document.getElementById("gotoBtn").style.display = "none";
//         }
//     } else if (errorStatus === 400) {
//         // testReport 에 400 에러가 있음(system configuration)
//         // alert("check Server URI");
//     }

//     gotoLoginBtn();
// }

export function getFetchError(res, json, isShowToast)
{
    // console.log('getFetchError', res, json);

    let toastStr = '';
    let toastStatus = '';
    let result = false;

    if( res.ok )
    {
        toastStr = 'success';
        toastStatus = 'success';
        result = true;
    }
    else
    {
        toastStr =
            <div>
                <div>{`${res.status} (${res.statusText})`}</div>
                <div>{`${res.url}`}</div>
            </div>;
        toastStatus = 'error';
        result = false;

        /*
            400 Parameter 가 요청이 이상하거나 서버에서 처리가 불가능한 경우
            401 유효하지 않은 토큰으로 요청 (로그인 페이지로 이동 처리)
            403 사용자 권한이 없음
            404 요청하는 item이 없음
            409 중복되는 값이 이미 있음
            500 서버에서 API를 처리하는 도중에 에러가 발생함
        */
        if( res.status === 401 )
        {
            let mainModal = document.getElementById('resButton');
            mainModal.value = JSON.stringify(json);
            document.getElementById('resButton').click();
        }
    }

    if( isShowToast )
    {
        showToast(toastStr, toastStatus);
    }
    
    return result;
}

export function getCatchError(err)
{
    if( sessionStorage.getItem('severCheckId') !== null )
    {
        return;
    }

    const intvMax = 10;
    let intvCnt = 0;

    let intvId = setInterval(function() {
        Promise.resolve( getPingCheckServer() )
        .then( done => {
            
            if( done !== 'done' )
            {
                intvCnt++;
                // console.log("Error message:", intvCnt, intvMax);
                if( intvCnt >= intvMax )
                {
                    sessionStorage.removeItem('severCheckId');
                    clearInterval(intvId);

                    let mainModal = document.getElementById('resButton');
                    mainModal.value = JSON.stringify({detail: 'There is a problem with the server'});
                    document.getElementById('resButton').click();
                }
                // console.log("Error message:", err.message);
                // console.log("Error name:", err.name);
                // console.log("Error stack:", err.stack);
            }
            else
            {
                sessionStorage.removeItem('severCheckId');
                clearInterval(intvId);
            }
        })
        .catch( err => {});
    }, 1000);

    sessionStorage.setItem('severCheckId', intvId);
}

// export const fetchErrorProcess = (res, data, isSuccessToast) => {

//     if( data.detail == null )
//     { 
//         if( res.ok && isSuccessToast )
//         {
//             showToast('success', 'success');
//         }
//     }
//     else
//     {
//         let errorStatus = res.status;
//         let errDetail = data.detail;

//         if ( errorStatus === 200 )
//         {
//             if( isSuccessToast )
//             {
//                 showToast('success', 'success');
//             }
//             return;
//         }
//         else
//         {
//             if( isSuccessToast )
//             {
//                 showToast(`${errDetail.code} (${errorStatus})`, 'error');
//             }
//         }

//         if ( errorStatus === 403 ) {

//             let notAuth = errDetail.indexOf('Not authenticated');
//             let invalidAuth = errDetail.indexOf('Invalid authentication');
//             let expiredToken = errDetail.indexOf('expired');
//             let invalidToken = errDetail.indexOf('Invalid token');

//             if (notAuth !== -1 || invalidAuth !== -1 || expiredToken !== -1 || invalidToken !== -1) {
//                 removeInterval();
//                 document.getElementById("gotoModal").style.display = "block"
//                 document.getElementById("gotoModal").classList.add("show");
//                 document.querySelector("#gotoModal .div-title").textContent = errDetail;
//                 document.querySelector("#gotoModal .div-message").textContent = "";
//             }
//         } else if (errorStatus === 401) {

//             let existServerMsg = errDetail.msg;
//             let timeMsg = errDetail.time;
//             let existServer = existServerMsg.indexOf('Does not exist on the server');
//             let temp = new Date(timeMsg * 1000);
    
//             let existTimeMsg = `${temp.getMonth()+1}/${temp.getDate()}/${temp.getFullYear()} ${temp.getHours()}:${temp.getMinutes()}:${temp.getSeconds()}`;
    
//             if (existServer !== -1) {
//                 removeInterval();
//                 document.getElementById("gotoModal").style.display = "block"
//                 document.getElementById("gotoModal").classList.add("show");
//                 document.querySelector("#gotoModal .div-title").textContent = "This account logged in from other device";
//                 document.querySelector("#gotoModal .div-message").textContent = existTimeMsg;
//             }

//         } else if (errorStatus === 500) {

//             let serverError = errDetail.indexOf('Server Error');

//             if (serverError !== -1) {
//                 removeInterval();
//                 document.getElementById("gotoModal").style.display = "block"
//                 document.getElementById("gotoModal").classList.add("show");
//                 document.querySelector("#gotoModal .modal-title").textContent = "";
//                 document.querySelector("#gotoModal .div-title").textContent = "Server Error!";
//                 document.querySelector("#gotoModal .div-title").style.color = "#dc3545";
//                 document.getElementById("gotoBtn").style.display = "none";
//             }
//         } else if (errorStatus === 400) {
//             // testReport 에 400 에러가 있음(system configuration)
//             // alert("check Server URI");
//         }

//         gotoLoginBtn();
//     }
// }

// export const checkTokenExp = () => {
//     clearInterval( parseInt(getCookie("accessTokenIntvID")) );

//     setCookie("accessTokenIntvID", String( setInterval(() => {

//         //cookie value null check
//         if( checkCookieNull() )
//         {
//             removeInterval();
//             return;
//         }
        
//         let accessTokenTime = parseInt( getCookie("accessTokenExp") );
    
//         let date = new Date();
//         let expTime = date.setTime(date.getTime());
    
//         let accessRemainTime = accessTokenTime*1 - expTime;

//         let tokenStatus = getCookie('tokenStatus');
        
//         // if(remainTime <= 120000 && tokenStatus === 'false' || remainTime < 0 && tokenStatus === 'true')
//         if(accessRemainTime <= 120000 && tokenStatus === 'false')
//         {
//             setCookie('tokenStatus', 'true');
                
//             setTimeout(() => {
//                 reissueToken();
//             }, 500);
//         }
//         else if(accessRemainTime <= 0)
//         {
//             let refreshTokenTime = parseInt( getCookie("accessTokenExp") );
//             let refreshRemainTime = refreshTokenTime*1 - expTime;

//             if(refreshRemainTime <= 0)
//             {
//                 document.getElementById("gotoModal").style.display = "block"
//                 document.getElementById("gotoModal").classList.add("show");
//                 document.querySelector("#gotoModal .div-title").textContent = "The session has expired or deleted!";
            
//                 gotoLoginBtn();
//             }
//             else
//             {
//                 setTimeout(() => {
//                     reissueToken();
//                 }, 500);
//             }
//         }
//     }, 1000) ));
// }

export const removeInterval = () => {
    let intvID = [];

    if( window.location.href.includes('sites-monitoring') )
    {
        // intvID.push(monStatusVar.alertInterval);
        // intvID.push(monStatusVar.summaryInterval);
        // intvID.push(monStatusVar.agentInterval);
        // intvID.push(monStatusVar.rmInterval);
    }
    intvID.push( Number(sessionStorage.getItem('ssMapRefreshIntvId')) );
    intvID.push( Number(sessionStorage.getItem('ssConnectRefreshIntvId')) );
    intvID.push( Number(sessionStorage.getItem('ssListRefreshIntvId')) );

    clearInterval( parseInt( getCookie("accessTokenIntvID") ) );

    intvID.forEach(function(item){
        if( item !== null )
        {
            clearInterval(item);
        }
    });
}

//배열의 오름차순 정렬
//array.sort((a, b) => strArraySortAsc(a.toLowerCase(), b.toLowerCase()));
export const strArraySortAsc = (sortA, sortB) => {
    if (sortA < sortB) return -1;
    if (sortA > sortB) return 1;
    return 0;
}

//배열의 내림차순 정렬
//array.sort((a, b) => strArraySortDesc(a.toLowerCase(), b.toLowerCase()));
export const strArraySortDesc = (sortA, sortB) => {
    if (sortA < sortB) return 1;
    if (sortA > sortB) return -1;
    return 0;
}

export const makeDoubleDigitYear = (now) => {
    let year = String(now);
    year = year + '';
    year = year.slice(2,4);

    return year;
}

export const makeDoubleDigitOther = (date) => {
    let result = String(date);
    if( date < 10 )
    {
        result = '0' + date;
    }

    return result;
}

// document.getElementById('updatedTime').textContent = updateDate();
// export const updateDate = () => {
//     const now = new Date();
    
//     const year = makeDoubleDigitYear(now.getFullYear());

//     const month = makeDoubleDigitOther(now.getMonth()+1);
//     const date = makeDoubleDigitOther(now.getDate());

//     const hours = makeDoubleDigitOther(now.getHours());
//     const minutes = makeDoubleDigitOther(now.getMinutes());
//     const seconds = makeDoubleDigitOther(now.getSeconds());

//     return date + "/" + month + "/" + year + " " + hours + ":" + minutes + ":" + seconds;
// }

export const updateUTCDate = (now) => {    
    const year = String(now.getFullYear());

    const month = makeDoubleDigitOther(now.getMonth()+1);
    const date = makeDoubleDigitOther(now.getDate());

    const hours = makeDoubleDigitOther(now.getHours());
    const minutes = makeDoubleDigitOther(now.getMinutes());
    const seconds = makeDoubleDigitOther(now.getSeconds());

    return year + "/" + month + "/" + date + " " + hours + ":" + minutes + ":" + seconds;
}

export const convertTzDate = (date) => {
    let stringDate = date.replace('T', ' ');
    stringDate = stringDate.replace('Z', ' ');

    let offset = stringDate.indexOf('.');
    if( offset !== -1 )
    {
        stringDate = stringDate.substring(0, offset);
    }

    return stringDate;
}

export const commonLogDate = () => {
    const now = new Date();
    
    const year = makeDoubleDigitYear(now.getFullYear());

    const month = makeDoubleDigitOther(now.getMonth()+1);
    const date = makeDoubleDigitOther(now.getDate());

    const hours = makeDoubleDigitOther(now.getHours());
    const minutes = makeDoubleDigitOther(now.getMinutes());
    const seconds = makeDoubleDigitOther(now.getSeconds());

    return `${year}${month}${date}_${hours}${minutes}${seconds}`;
}

export const commonLogDate2 = () => {
    const now = new Date();
    
    const year = now.getFullYear();

    const month = makeDoubleDigitOther(now.getMonth()+1);
    const date = makeDoubleDigitOther(now.getDate());

    const hours = makeDoubleDigitOther(now.getHours());
    const minutes = makeDoubleDigitOther(now.getMinutes());
    const seconds = makeDoubleDigitOther(now.getSeconds());

    return `${year}${month}${date}_${hours}${minutes}${seconds}`;
}

export const dateToCalendar = (now) => {    
    const year = String(now.getFullYear());

    const month = makeDoubleDigitOther(now.getMonth()+1);
    const date = makeDoubleDigitOther(now.getDate());

    const hours = makeDoubleDigitOther(now.getHours());
    const minutes = makeDoubleDigitOther(now.getMinutes());

    return year + "-" + month + "-" + date + "T" + hours + ":" + minutes;
}

//metricToObject Start
export const find_value = (key, str) => {
    let end = 0;
    let exist_special = false;

    for(let num in str)
    {
        let i = parseInt(num);
        let c = str[i];

        if(exist_special)
        {
            exist_special = false;
            continue;
        }

        if(c === '\\')
        {
            exist_special = true;
        }
        else if(c === '"')
        {
            end = i + 1;
            break;
        }
    }

    if(end === 0)
    {
        return undefined;
    }

    return {
        'key': key,
        'value':  str.substring(0, end-1),
        'end': end
    };
}

export const find_label = (str) => {
    let idx = str.indexOf("=");

    if(idx === -1)
    {
       return undefined;
    }

    let label = str.substring(0, idx);
    label = label.replaceAll(' ', '');
    label = label.replaceAll(',', '');
    idx = str.indexOf("\"", idx);
    let rs = find_value(label, str.substring(idx+1));

    if(rs === undefined)
    {
        return undefined;
    }

    rs['end'] = rs['end'] + idx + 2;

    return rs;
}

export const parse_labels = (str) => {
    let len = str.length;
    let pos = 0;
    let obj = {};

    while (len > pos)
    {
        let rs = find_label(str.substring(pos));

        if(rs === undefined)
        {
            return undefined;
        }

        pos += rs['end'];
        let key = rs['key'];
        let val = rs['value'];
        let found = key.match(/\w*/);

        if(found[0] !== key)
        {
            return undefined;
        }

        obj[key] = val;
    }

    return obj;
}

export const parse_metric = (str) => {
    let start = str.indexOf('{');
    let end = str.lastIndexOf('}');

    if(start === -1 && end === -1)
    {
        let arr = str.split(' ');

        if(arr.length !== 2)
        {
            return undefined;
        }

        let obj = {
            'key': arr[0],
            'value': arr[1],
            'labels' : {},
        }

        return obj;
    }
    else if(start >= 0 && end >= 0)
    {
        let metric_name = str.substring(0, start).trim();
        let metric_vale = str.substring(end+1).trim();
        let labels_str = str.substring(start+1, end);
        let rs = parse_labels(labels_str);

        if(rs === undefined)
        {
            return undefined;
        }

        let obj = {
            'key': metric_name,
            'value': metric_vale,
            'labels' : rs,
        }

        return obj;
    }
    else
    {
        return undefined;
    }
}

export const parse_metrics_body = (inputMetric) => {
    let metric_arr = inputMetric.split('\n');
    let obj = {};
    let fail_count = 0;
    
    try{
        for(let i in metric_arr)
        {
            let str = metric_arr[i];
            let idx = str.indexOf('#');

            if(idx === 0){
                continue;
            }

            if(str.length === 0){
                continue;
            }

            let rs = parse_metric(str);
            if(rs === undefined){
                fail_count += 1;
                continue;
            }

            let key = rs['key'];
            let value = rs['value'];
            let labels = rs['labels'];

            if(!(key in obj)){
                obj[key] = [];
            }

            obj[key].push({
                'labels': labels,
                'value': value,
            });
        }
    }catch (err){
        console.log(err);
    }
    
    return {
        'metrics': obj,
        'failCount': fail_count
    };
}
//metricToObject End

//3자리 이상의 숫자에 천단위 구분 (,)을 넣어줌
export const priceToString = (price) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// export const getTimeStamp = (date = new Date()) => {
//     return  (date.getTime()/1000) | 0;
// }

// export const addHttpDeviceLink = (url) => {
//     if( !url.toLowerCase().includes('http://') && !url.toLowerCase().includes('https://') )
//     {
//         url  = 'http://' + url;
//     }

//     return url;
// }

// export const moveDeviceLink = () => {
//     let url = addHttpDeviceLink(this.getAttribute('link'));
//     var win = window.open( url );
//     win.focus();
// }

// export const isEmptyObj = (param) => {
//     return Object.keys(param).length === 0;
// }

// export const initDateAnalytic = (NOW) => {
//     const YEAR = String(NOW.getFullYear());

//     const MONTH = makeDoubleDigitOther(NOW.getMonth()+1);
//     const DATE = makeDoubleDigitOther(NOW.getDate());

//     const HOURS = makeDoubleDigitOther(NOW.getHours());
//     const MINUTES = makeDoubleDigitOther(NOW.getMinutes());

//     return `${YEAR}-${MONTH}-${DATE}T${HOURS}:${MINUTES}`;
// }

export const setBrowserDate = (date) => {
    let safariFlag = isNaN(new Date(date).getTime())
    let mills;
    let arr = date.split('.');

    date = arr[0];
    mills = arr[1];
    
    if( safariFlag )
    {
        date = date.replace(/-/g, "/");
    }

    return {date: new Date(date), mills: mills};
}

export const checkApiDataResult = (data) => {
    if( !data )
    {
        return true;
    }
    
    if( !data.data.result || data.data.result.length < 1 )
    {
        return true;
    }

    return false;
}

// export const checkApiDataMetrics = (data) => {
//     if( !data )
//     {
//         return true;
//     }
        
//     if( !data.metrics )
//     {
//         return true;
//     }
    
//     return false;
// }

// export const makeResultData = (start, end, step, result ) => {
//     let mergeData = [];
//     let checkData = [];

//     for(let value of result)
//     {
//         let addData = Number(value[1]);
//         let timeLabel = value[0];

//         for(let idx = start + step; idx < timeLabel; idx += step )
//         {
//             checkData.push([idx, null]);
//         }

//         start = timeLabel;
//         checkData.push([timeLabel, addData]);
//     }

//     while((end - start) >= step )
//     {
//         checkData.push([start + step, null]);
//         start += step;
//     }
    
//     return mergeData.concat(checkData);
// }

// export const getServerName = () => {
//     getApiSystemVersion()
//     .then(data => 
//     {
//         if(data)
//         {
//             let serverName = data.serverName;
//             document.getElementById('serverName').textContent = serverName;
//         }
//     })
// }

export function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
  }, [delay]);
}

export const toGoogleMap = (loc) => {
    var win = window.open(`https://www.google.com/maps/search/?api=1&query=${loc}`, 'FindLocation');
    win.focus();
}

export const createNewTab = (url) => {
    if( url.length < 1 )
    {
        url = '';
    }
    else if( !url.toLowerCase().includes('http://') && !url.toLowerCase().includes('https://') )
    {
        url  = 'http://' + url;
    }

    var win = window.open(url);
    win.focus();
}

export const showToast = (text, type, autoClose=2000) => {
    let option = {position:"bottom-right", autoClose:autoClose, pauseOnFocusLoss:false, pauseOnHover:true, transition:Slide, theme: 'dark'}
    
    switch(type)
    {
        case 'info':
            toast.info(text, option);
            break;
        case 'warning':
            toast.warning(text, option);
            break;
        case 'error':
            toast.error(text, option);
            break;            
        case 'success':
            toast.success(text, option);
            break;
        default:
            toast.info(text, option);
            break;
    }
    
    //Test
    // toast.info(text, option);
    // setTimeout(() => {
    //     toast.warning(text, option);
    //     setTimeout(() => {
    //         toast.error(text, option);
    //         setTimeout(() => {
    //             toast.success(text, option);
    //         }, 500);
    //     }, 500);
    // }, 500);
}

export const stateMapAdd = (key, value, mapState) => {
    mapState((prev) => new Map([...prev, [key, value]]));
};

export const stateMapUpset = (key, value, mapState) => {
    mapState((prev) => new Map(prev).set(key, value));
}

export const stateMapDelete = (key, mapState) => {
    mapState((prev) => {
        const newState = new Map(prev);
        newState.delete(key);
        return newState;
    });
}

export const stateMapClear = (mapState) => {
    mapState((prev) => new Map(prev.clear()));
}

export const refMapAdd = (key, value, refState) => {
    refState.current = new Map([...refState.current, [key, value]]);
};

export const refMapDelete = (key, refState) => {
    const newState = new Map(refState.current);
    newState.delete(key);
    refState.current = newState;
}

export const refMapClear = (refState) => {
    refState.current = new Map(refState.current.clear());
}

export const getEdgeAlertStatus = (alertArr) => {
    let status = 0;

    if( alertArr.length > 0 )
    {
        let firing = alertArr.filter((x) => {return x.status === 'firing'});
        if( firing.length > 0 )
        {
            if( firing.filter((x) => {return x.severity === 'critical' || x.severity === 'error'}).length > 0 )
            {
                status = 2;
            }
            else if( firing.filter((x) => {return x.severity === 'warning'}).length > 0 )
            {
                if( status < 2 )
                {
                    status = 1;
                }
            }
        }
    }

    return `${status===0?'bg-good':status===1?'bg-warning':'bg-critical'}`;
}

// export const compareAlertStatus = (pre, cur) => {

//     let result = pre;
//     // if( pre === 'bg-critical' )
//     // {
//     //     result = pre;
//     // }
//     if( pre === 'bg-warning' )
//     {
//         if( cur === 'bg-critical' )
//         {
//             result = cur;
//         }
//     }
//     else if( pre === 'bg-good' )
//     {
//         if( cur !== 'bg-good' )
//         {
//             result = cur;
//         }
//     }
    
//     return result;
// }

export function getHighSeveriry(arr)
{
    if( arr.indexOf('bg-critical') !== -1 )
    {
        return 'bg-critical';
    }
    else if( arr.indexOf('bg-warning') !== -1 )
    {
        return 'bg-warning';
    }
    else 
    {
        return 'bg-good';
    }
}

// export function initDateTime(NOW)
// {
//     const YEAR = String(NOW.getFullYear());

//     const MONTH = makeDoubleDigitOther(NOW.getMonth()+1);
//     const DATE = makeDoubleDigitOther(NOW.getDate());

//     const HOURS = makeDoubleDigitOther(NOW.getHours());
//     const MINUTES = makeDoubleDigitOther(NOW.getMinutes());

//     return `${YEAR}-${MONTH}-${DATE}T${HOURS}:${MINUTES}`;
// }

export function downloadFile(writeMsg, fileName)
{
    let filePath = `${commonLogDate()}_${fileName}.txt`;
    let element = document.createElement('a');
    element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(writeMsg));
    element.setAttribute('download', filePath);
    document.body.appendChild(element);
    element.click();
    element.remove();
}

export function utcToLocalDate(dateStr)
{
    let getDate = setBrowserDate(dateStr);
    
    let now = getDate.date;
    let offset = (now.getTimezoneOffset() * -1) * 60 * 1000;
    now = new Date(now.getTime() + offset);

    const year = String(now.getFullYear());

    const month = makeDoubleDigitOther(now.getMonth()+1);
    const date = makeDoubleDigitOther(now.getDate());

    const hours = makeDoubleDigitOther(now.getHours());
    const minutes = makeDoubleDigitOther(now.getMinutes());
    const seconds = makeDoubleDigitOther(now.getSeconds());

    // return year + "/" + month + "/" + date + " " + hours + ":" + minutes + ":" + seconds + "." + getDate.mills;
    return year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
}

export const getNowDate = ()=> {
    const now = new Date();
    const year = String(now.getFullYear());

    const month = makeDoubleDigitOther(now.getMonth()+1);
    const date = makeDoubleDigitOther(now.getDate());

    const hours = makeDoubleDigitOther(now.getHours());
    const minutes = makeDoubleDigitOther(now.getMinutes());

    return [
        year + "-" + month + "-" + date + "T" + hours + ":" + minutes,
        year + "-" + month + "-" + date + " " + hours + ":" + minutes
    ];
}

const secretKey = '12345678901234567890123456789012' // 32자리 비밀키
const iv = 'abcdefghijklmnop' // 16자리 iv
// 암호화
export const encrypt = (text) => {
    const cipher = CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(secretKey), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
    });

    return cipher.toString();
}

// 복호화
export const decrypt = (encryptedText) => {
    if (!encryptedText) return null;
    try {
        const decipher = CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Utf8.parse(secretKey), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC,
        })
        return decipher.toString(CryptoJS.enc.Utf8);
    } catch (e) {
        return null;
    }
}

export const setEncryptCookie = (name, value, exp) => {

    return setCookie(name, encrypt(value), exp);
}

export const getDecryptCookie = (name) => {
    const value = getCookie(name);
    if (!value) return null;
    return decrypt(value);
}

export const getMapStyle = (style) => {
    
    const MapStyle = {
        Streets: 'mapbox://styles/mapbox/streets-v12',
        Outdoors: 'mapbox://styles/mapbox/outdoors-v12',
        Satellite: 'mapbox://styles/mapbox/satellite-v9',
        Light: 'mapbox://styles/mapbox/light-v11',
        Dark: 'mapbox://styles/mapbox/dark-v11',
        Satellite_Streets: 'mapbox://styles/mapbox/satellite-streets-v12',
        Navigation_Day: 'mapbox://styles/mapbox/navigation-day-v1',
        Navigation_Night: 'mapbox://styles/mapbox/navigation-night-v1',
    }

    if( !MapStyle[style] )
    {
        return MapStyle[0];
    }

    return MapStyle[style];
}

export function cutFloatlength(str)
{
    return parseFloat(str).toFixed(5);
}

export function saveIfChange(setState, value)
{
    setState(prevState => {
        // 이전 상태를 사용하여 새로운 상태를 계산
        if (prevState !== value) {
            return value; // 새로운 상태 반환
        } else {
            return prevState; // 변화 없음, 이전 상태 그대로 반환, 렌더링하지 않음
        }
    });
}

export function getMetricProperty(metricsObj, metricsName)
{
    if( metricsObj.hasOwnProperty(metricsName) && metricsObj[metricsName].length )
    {
        return metricsObj[metricsName];
    }

    return null;
}

export function getSession_Json(ssName)
{
    const get = sessionStorage.getItem(ssName);

    if( get === null )
    {
        return null;
    }

    return JSON.parse(get);    
}

export function updateSession(ssName, nameIdx, value)
{
    const get = sessionStorage.getItem(ssName);

    if( get !== null )
    {
        const json = JSON.parse(get);  
        const newVal = {...json, [nameIdx]: value };
        sessionStorage.setItem(ssName, JSON.stringify(newVal));
    }  
}

export function getPemission()
{
    let type =  getDecryptCookie('type');
    let status = 0;

    if( type != null )
    {
        if( type.toLowerCase().includes('admin') )
        {
            status = 2;
        }
        else if( type.toLowerCase().includes('operator') )
        {
            status = 1;
        }
    }

    return status;
}

// 이메일 유효성 검사 함수
export const isValidEmail = (email) =>
{
    // 1. 로컬 파트에서 마침표(.)가 연속으로 오거나 처음/끝에 올 수 없음
    // 2. 도메인 파트에서 마침표(.)가 연속으로 오거나 처음/끝에 올 수 없음
    const emailRegex = /^[a-zA-Z0-9]+([\._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+([\.-]?[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};